module.exports = __webpack_public_path__ + "newsletter/Components/PocketHitsSignup/images/publishers/logo-narratively.2bad2936c51eb8ff8ee0373ce5d84cce.png";